import { render, staticRenderFns } from "./TableLaboratory.vue?vue&type=template&id=7ecec06f"
import script from "./TableLaboratory.vue?vue&type=script&lang=js"
export * from "./TableLaboratory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports